export const mockOfficeSpaces = [
  {
    id: 1,
    title: 'Single Seater Cabin',
    description: 'Perfect for freelancers and solo professionals. A private, fully-equipped workspace designed for focused productivity.',
    capacity: 'Ideal for 1 person',
    term: 'Monthly or Yearly',
    units: 10,
    available: true,
    image: './images/galery-images/IMG_6840.JPG'
  },
  {
    id: 2,
    title: '2 Seater Cabin',
    description: 'Ideal for small teams or partnerships. Collaborate effectively in a professional private space.',
    capacity: 'Ideal for 2 people',
    term: 'Monthly or Yearly',
    units: 4,
    available: true,
    image: './images/galery-images/IMG_E6813.JPG'
  },
  {
    id: 3,
    title: '6 Seater Cabin',
    description: 'Designed for growing teams. A spacious private cabin with room for collaboration and individual work.',
    capacity: 'Ideal for 6 people',
    term: 'Monthly or Yearly',
    units: 1,
    available: true,
    image: './images/galery-images/IMG_E6810.JPG'
  },
  {
    id: 4,
    title: 'Customized Office',
    description: 'When off-the-shelf isn\'t enough. Fully customizable space with your choice of furniture, layout, and branding.',
    capacity: 'Customizable capacity',
    term: 'Monthly or Yearly + Customization',
    units: 1,
    available: true,
    image: './images/galery-images/IMG_E6811.JPG'
  },
  {
    id: 5,
    title: 'Meeting Room',
    description: 'Professional meeting space perfect for client presentations, team meetings, or interviews. Book by the hour.',
    capacity: 'Seats 6-8 people',
    term: 'Hourly or Daily',
    units: 1,
    available: true,
    image: './images/galery-images/NTLE0082.JPG'
  }
];
